import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "Tokyo Game Show VR 2021"
const scope = "クリエイティブ・ディレクション"
const str1 = "東京ゲームショウ初のバーチャル会場「TGSVR2021」のクリエイティブ・ディレクションを行った。"
const str2 = "現実の海上のどこかにある「ゲームフロート」に世界中の人が自宅からアクセスして楽しむというストーリー・舞台設定とし、出展スペースを通り抜ける円環構造や、画像・動画を引き寄せて視聴する機能など、VR以降の大規模展示会のあり方を探った。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.tgsvr202101.childImageSharp.original.src}
          pageimgw={data.tgsvr202101.childImageSharp.original.width}
          pageimgh={data.tgsvr202101.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/tgsvr202101.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  tgsvr202101: file(relativePath: {eq: "tgsvr202101.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
